import { Input, List, Select } from "antd";
import React from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { onlyNumbers } from "Helpers/onlyNumbers";
export const WorksList = ({
  items = [],
  disabled = false,
  onChange = () => {},
  groups = [],
  margin = "0 0 0 0",
  borderTop = "",
  borderRadius = "",
}) => {
  return (
    <List
      style={{ margin, borderTop, borderRadius }}
      bordered
      dataSource={items}
      renderItem={(item) => (
        <List.Item
          actions={[
            <a>
              <DeleteOutlined
                style={{ color: disabled ? "grey" : "red" }}
                onClick={() => {
                  if (disabled) return;
                  onChange("deleteAllowedWorkTypes", {
                    workId: item.id,
                    allowedWorkId: item.allowedWorkType.id,
                  });
                }}
              />
            </a>,
          ]}
        >
          <div
            style={{
              display: "flex",
              gap: 12,
              width: "100%",
            }}
          >
            <Select
              disabled={disabled}
              placeholder="Група"
              style={{ width: 140 }}
              value={item?.allowedWorkType?.groupId}
              onChange={(groupId) => {
                onChange("changeGroup", {
                  groupId,
                  itemId: item.id,
                  allowedWorkId: item.allowedWorkType.id,
                });
              }}
            >
              {groups.map((g) => (
                <Select.Option key={g.id} value={g.id}>
                  {g.title}
                </Select.Option>
              ))}
              <Select.Option key={null} value={null}></Select.Option>
            </Select>

            <Input value={item?.code} disabled style={{ width: 120 }} />

            <Input
              value={`${item?.title}, ${item?.unit}`}
              disabled
              style={{ flex: 1 }}
            />

            <Input
              disabled={disabled}
              placeholder="План"
              style={{ width: 120 }}
              value={item?.allowedWorkType?.plannedValue}
              onChange={(e) => {
                const val = onlyNumbers(e.target.value);

                onChange("changePlannedValue", {
                  workId: item.id,
                  value: val ? Number(val) : null,
                  allowedWorkId: item.allowedWorkType.id,
                });
              }}
            />
          </div>
        </List.Item>
      )}
    />
  );
};
